import React, { useEffect, useState } from 'react';
import useAppState from '../../state/appState';
import { isElementVisible } from '../../conditional-fields/evaluate-field-condition';
import { getArrayOfPagesShown } from '../../helpers/getPageInfo';
import { isFieldValid } from '../values/Get';
import { getPageIdFromURL } from '../../helpers/getPageIdFromURL';

export const PageAndFieldValidityForCurrentPage = () => {
    const formConfig = useAppState((state) => state.formConfig);
    const formValues = useAppState((state) => state.formValues);

    type Element = {
        elementId: string;
        isValid: boolean | undefined;
    };

    type PagesAndFields = {
        pageId: string;
        isValid: boolean;
        elements: Element[];
    };

    const [pagesAndFields, setPagesAndFields] = useState<PagesAndFields[]>([]);

    useEffect(() => {
        if (!formConfig) {
            return;
        }

        getArrayOfPagesShown(formConfig, formValues).then((pageArray) => {
            const pagesAndFields = pageArray.map((pageId) => {
                const elements: Element[] = [];

                const page = formConfig.pages.find((page) => page.pageId === pageId);

                if (page) {
                    page.elements.forEach((element) => {
                        const { elementId } = element;

                        if (!isElementVisible(formConfig, formValues, elementId)) {
                            return;
                        }

                        const isValid = isFieldValid(formConfig, formValues, elementId);

                        elements.push({
                            elementId,
                            isValid
                        });
                    });
                }

                // If ALL elements on a page are valid,
                // the page is valid
                const isPageValid = elements.every((element) => {
                    return element.isValid;
                });

                return {
                    pageId,
                    isValid: isPageValid,
                    elements
                };
            });

            setPagesAndFields(pagesAndFields);
        });
    }, [formConfig, formValues]);

    if (!formConfig) {
        return <></>;
    }

    const pageIdCur = getPageIdFromURL();

    return (
        <div>
            {pagesAndFields.map((paf, i) => {
                const { pageId, isValid, elements } = paf;

                if (pageId !== pageIdCur) {
                    return <div key={i}></div>;
                }

                let color = undefined;
                switch (isValid) {
                    case true:
                        color = '#00AA00';
                        break;
                    case false:
                        color = '#FF0000';
                        break;
                }

                return (
                    <div key={i} style={{ color }}>
                        <b>{pageId}</b>
                        <br />
                        <ul>
                            {elements.map((element, i) => {
                                const { elementId, isValid } = element;

                                let color = undefined;
                                switch (isValid) {
                                    case undefined:
                                        color = '#FFFF00';
                                        break;
                                    case true:
                                        color = '#00AA00';
                                        break;
                                    case false:
                                        color = '#FF0000';
                                        break;
                                }

                                return (
                                    <div key={i} style={{ color }}>
                                        <li> {elementId}</li>
                                    </div>
                                );
                            })}
                        </ul>
                    </div>
                );
            })}
        </div>
    );
};
